import { useState } from 'react';

import { FooterNavigator } from '../Footer/FooterNavigator';
import { ConfirmAction } from './Modals/ConfirmAction';
import { useStrategiesContext } from './StrategiesContext';
import { Inputvent } from './types';

export const RenameDuplicate = () => {
  const {
    loadingChangeName,
    loadingStrategies,
    option,
    strategy,
    closeModal,
    dispatch,
    cloneStrategy,
    setStrategyName,
    loadingClone,
    refetchStrategies,
  } = useStrategiesContext();
  const acceptButtonName = option === 'Rename' ? 'Save' : 'Duplicate';

  const [input, setInput] = useState(strategy?.name || '');

  const handleOnChange = ({ target: { value } }: Inputvent) => setInput(value);

  const duplicateStrategy = () => {
    const variables = { strategyId: strategy?.id, name: input };

    cloneStrategy &&
      cloneStrategy({
        variables,
        onCompleted: async () => {
          refetchStrategies?.().then(() => {
            closeModal();
            dispatch({
              element: (
                <ConfirmAction action="duplicated" strategyName={input} />
              ),
              loadingStrategyActivationId: undefined,
            });
          });
        },
      });
  };

  const saveChanges = () => {
    acceptButtonName === 'Save' &&
      setStrategyName!({
        variables: {
          strategyId: strategy?.id,
          name: input,
        },
      }).then(() => closeModal());

    acceptButtonName === 'Duplicate' && duplicateStrategy();
  };

  return (
    <div className="flex flex-col h-full justify-between px-20 mt-10">
      <div className="flex flex-col text-sm my-10">
        Name
        <input
          className={`
            w-full
            border-b-1
            border-black
            dark:border-white
            pb-2
            text-lg
            dark:bg-grey-90
          `}
          placeholder="Strategy name"
          value={input}
          onChange={handleOnChange}
        />
      </div>

      {/* footer */}
      <FooterNavigator
        loading={loadingChangeName || loadingStrategies || loadingClone}
        saveButtonName={acceptButtonName}
        className="h-28 mb-10"
        // TODO inform the user if the action cannot be performed
        isDisabledSaveButton={
          input.trim().length < 3 || input === strategy?.name
        }
        onCancel={closeModal}
        onSave={saveChanges}
      />
    </div>
  );
};
